'use strict';

import React, { Component } from 'react';
import NewBox from  './module/paygoNewBoxToAdminAssociation.jsx';

class Card extends Component{

state = {
            //Initiate Default User
            NumberOfBox: "",
            popupStateBoxToAdmin: "overlay hidden",
            NumberOfBoxAssociation: "",
        }
    closeOverlay= () => {
      this.setState({
      popupStateBoxToAdmin: "overlay hidden",
    });
    }
    newBoxToAdmin= (e) => {
        e.preventDefault();
        this.setState({popupStateBoxToAdmin: "overlay"});
    }
    componentDidMount= () => {
    }
    componentWillUnmount() {
        try {
        } catch (e) {
            console.log(e);
        }
    }
    render() {
        return (
            <div className="container">  
                <div className="col-sm-4">
                    <div className="card">
                        <div className="card-header bgm-cyan">
                            <h2>Box Management
                                <small></small>
                            </h2>

                            <ul className="actions actions-alt">
                                <li className="dropdown hidden">
                                    <a href="" data-toggle="dropdown" aria-expanded="false">
                                        <i className="zmdi zmdi-more-vert"></i>
                                    </a>

                                    <ul className="dropdown-menu dropdown-menu-right">
                                        <li>
                                            <a href="">Refresh</a>
                                        </li>

                                    </ul>
                                </li>
                            </ul>
                        </div>

                        <div className="card-body card-padding">
                            Number of Box: {this.state.NumberOfBox}<p></p>
                          <button className="btn btn-primary" onClick={this.newBoxToAdmin}>Attribute a Box to an Admin </button>
                        </div>
                    </div>
                </div>

                <NewBox popupState={this.state.popupStateBoxToAdmin} onCloseOverlay={this.closeOverlay}/>
            </div>
        );
    }
};
export default Card;

//module.exports = Card;
